import moment from 'moment';

function isUtcDateTimeFilter() {
    return (value: string): boolean =>
        moment(value, moment.ISO_8601, true).isValid();
}

export default {
    name: 'isUtcDateTime',
    definition: isUtcDateTimeFilter
};
